import { TSharedDialogInstance, TSharedDialogOptions } from "./sharedDialogTypes";

interface IDialogHostBridge {
  mountDialog: (dialog: TSharedDialogInstance, sharedState: unknown) => void;
  unmountDialog: (id: string) => void;
}

export class SharedDialogService {
  private dialogHostBridge: IDialogHostBridge | undefined;

  public setSharedDialogApi(hostBridge: IDialogHostBridge | undefined): void {
    this.dialogHostBridge = hostBridge;
  }

  private get existingDialogHostBridge(): IDialogHostBridge {
    if (!this.dialogHostBridge) {
      throw new Error("SharedDialogProvider is not mounted. Mount it at app root before calling sharedDialog.");
    }

    return this.dialogHostBridge;
  }

  public openSharedDialog(options: TSharedDialogOptions): void {
    const dialogId = `shared-dialog-${crypto.randomUUID()}`;

    this.existingDialogHostBridge.mountDialog({ ...options, id: dialogId }, options.sharedState);
  }

  public closeSharedDialog(id: string): void {
    this.existingDialogHostBridge.unmountDialog(id);
  }
}

export const sharedDialog = new SharedDialogService();
